<template>
  <div class="container" :style="{width: screenWidth + 'px', height: screenHeight + 'px'}">
    <div class="box">
      <h2>找回密码</h2>
      <template v-if="type==='0'">
        <el-input style="margin-top: 10px" placeholder="请输入账号" v-model="account"/>
        <el-input style="margin-top: 10px" placeholder="请输入手机号" v-model="phone"/>
        <div
            style="display: flex;flex-direction: row;justify-content: flex-start;align-items: center;width: 100%;margin-top: 10px">
          <el-input placeholder="请输入手机号验证码" v-model="code"/>
          <el-button type="primary" style="margin-left: 10px" :disabled="timerNum<60||timerNum===0"
                     @click="sendCodeAction">
            <span v-if="timerNum===60||timerNum===0">获取验证码</span>
            <span v-else>{{ timerNum }}s</span>
          </el-button>
        </div>
      </template>
      <template v-else>
        <el-input style="margin-top: 10px" v-model="password" placeholder="请输入新密码"
                  show-password></el-input>
        <el-input style="margin-top: 10px" v-model="aPassword" placeholder="请再次输入新密码"
                  show-password></el-input>
      </template>
      <div class="login_btn" @click="loginAction">提交</div>
      <div class="register_btn" @click="toRegister">已经有账号,直接登录</div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

import {register, sendCode, updatePasswordWithAccountAndPassword, verifyPhoneAndAccount} from "@/api/index";
import {MessageBox, Message} from "element-ui";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Login",
  data() {
    return {
      account: "",
      phone: "",
      code: "",
      timer: null,
      timerNum: 60,
      type: "0",
      password: "",
      aPassword: "",
    };
  },
  computed: {
    ...mapState([
      "screenHeight",
      "screenWidth"
    ])
  },
  methods: {
    sendCodeAction() {
      if (this.phone.length === 0) {
        Message.error("手机号不能为空!");
        return;
      }
      sendCode({
        phone: this.phone,
      }).then(res => {
        if (res.data.code === 200) {
          Message.success("短信发送成功!")
          this.code = "123456"
          this.timer = setInterval(() => {
            if (this.timerNum > 0) {
              this.timerNum--;
            } else {
              this.timerNum = 60
              clearInterval(this.timerNum);
            }
          }, 1000)
        } else {
          Message.success("短信发送失败!")
        }
      })
    },
    toRegister() {
      this.$router.push({
        path: "/login"
      });
    },
    loginAction() {
      if (this.type === '0') {
        if (this.account.length === 0) {
          Message.error("账号不能为空!");
          return;
        }
        if (this.phone.length === 0) {
          Message.error("手机号不能为空!");
          return;
        }
        if (this.code.length === 0) {
          Message.error("验证码不能为空!");
          return;
        }
        verifyPhoneAndAccount({
          phone: this.phone,
          account: this.account,
          code: this.code
        }).then((res) => {
          if (res.data.code === 200) {
            this.type = "1"
          } else {
            Message.error(res.data.result);
          }
        });
      } else {
        if (this.account.length === 0) {
          Message.error("账号不能为空!");
          return;
        }
        if (this.phone.length === 0) {
          Message.error("手机号不能为空!");
          return;
        }
        if (this.password.length === 0) {
          Message.error("密码不能为空!");
          return;
        }
        if (this.aPassword.length === 0) {
          Message.error("密码不能为空!");
          return;
        }
        if (this.aPassword !== this.password) {
          Message.error("两次输入密码不一致!");
          return;
        }
        updatePasswordWithAccountAndPassword({
          phone: this.phone,
          account: this.account,
          password: this.password
        }).then((res) => {
          if (res.data.code === 200) {
            Message.error("修改成功!")
            this.$router.push({
              path: "/login"
            })
          } else {
            Message.error(res.data.result);
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 200px;
  background-image: url("../assets/bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;

  .box {
    width: 400px;
    padding: 30px;
    background-color: white;
    border-radius: 8px;

    .login_btn {
      width: 100%;
      background-color: #1FA4FF;
      margin-top: 40px;
      height: 40px;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      cursor: pointer;
    }

    .register_btn {
      font-size: 15px;
      margin-top: 15px;
      cursor: pointer;
    }
  }
}
</style>
